<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <div class="row">

                <div class="col-3">
                    <ValidationProvider
                        name="event_name"
                        rules="required"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('event_name')">
                            <b-form-input
                                v-model="form.event_name"
                            ></b-form-input>
                            <b-form-invalid-feedback
                                v-if="errors[0]"
                                v-html="errors[0]"
                            ></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-3">
                    <ValidationProvider name="event_type" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('event_type')">
                            <department-selectbox  :multiple="true"
                                                   :validate-error="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-3">
                    <ValidationProvider
                        name="event_location"
                        rules="required"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('event_location')">
                            <b-form-input
                                v-model="form.event_location"
                            ></b-form-input>
                            <b-form-invalid-feedback
                                v-if="errors[0]"
                                v-html="errors[0]"
                            ></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-3">
                    <ValidationProvider name="event_format" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('event_format')">
                            <department-selectbox  :multiple="true"
                                                   :validate-error="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-3">
                    <ValidationProvider
                        name="etkinlik_tarihi"
                        rules="required"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('event_start_date')">
                            <b-form-input type="date"/>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-3">
                    <ValidationProvider
                        name="event_end_date"
                        rules="required"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('event_end_date')">
                            <b-form-input type="date"/>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-3">
                    <ValidationProvider
                        name="event_announcement"
                        rules=""
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('event_announcement')">
                            <b-form-textarea
                                v-model="form.etkinlik_duyurusu"
                            ></b-form-textarea>
                            <b-form-invalid-feedback
                                v-if="errors[0]"
                                v-html="errors[0]"
                            ></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-3">
                    <ValidationProvider
                        name="participant_count"
                        rules="required"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('participant_count')">
                            <b-form-input
                                type="number"
                                v-model="form.participant_count"
                            ></b-form-input>
                            <b-form-invalid-feedback
                                v-if="errors[0]"
                                v-html="errors[0]"
                            ></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-3">
                    <ValidationProvider name="external_participation" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('external_participation')">
                            <department-selectbox  :multiple="true"
                                                   :validate-error="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-3">
                    <ValidationProvider
                        name="there_is_a_protocol"
                        rules="required"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('there_is_a_protocol')">
                            <b-form-select :options="options"
                                           />
                            <span class="invalid-feedback-custom"/>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-3">
                    <ValidationProvider
                        name="speaker_lecturer"
                        rules="required"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('speaker_lecturer')">
                            <b-form-input
                                v-model="form.speaker_lecturer"
                            ></b-form-input>
                            <b-form-invalid-feedback
                                v-if="errors[0]"
                                v-html="errors[0]"
                            ></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-3">
                    <ValidationProvider
                        name="bütçe"
                        rules=""
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('budget')">
                            <b-form-input
                                v-model="form.budget"
                            ></b-form-input>
                            <b-form-invalid-feedback
                                v-if="errors[0]"
                                v-html="errors[0]"
                            ></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-3">
                    <ValidationProvider
                        name="budget_items"
                        rules="required"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('budget_items')">
                            <b-form-input
                                v-model="form.budget_items"
                            ></b-form-input>
                            <b-form-invalid-feedback
                                v-if="errors[0]"
                                v-html="errors[0]"
                            ></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-3">
                    <ValidationProvider
                        name="material_requests"
                        rules="required"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('material_requests')">
                            <b-form-textarea
                                v-model="form.material_requests"
                            ></b-form-textarea>
                            <b-form-invalid-feedback
                                v-if="errors[0]"
                                v-html="errors[0]"
                            ></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-3">
                    <ValidationProvider
                        name="printed_materials"
                        rules=""
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('printed_materials')">
                            <b-form-textarea
                                v-model="form.printed_materials"
                            ></b-form-textarea>
                            <b-form-invalid-feedback
                                v-if="errors[0]"
                                v-html="errors[0]"
                            ></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-3">
                    <ValidationProvider
                        name="ikram"
                        rules=""
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('complimentary')">
                            <b-form-textarea
                                v-model="form.complimentary"
                            ></b-form-textarea>
                            <b-form-invalid-feedback
                                v-if="errors[0]"
                                v-html="errors[0]"
                            ></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>

                <div class="col-3">
                    <ValidationProvider
                        name="attendees_for_refreshments"
                        rules=""
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('attendees_for_refreshments')">
                            <b-form-input
                                v-model="form.attendees_for_refreshments"
                            ></b-form-input>
                            <b-form-invalid-feedback
                                v-if="errors[0]"
                                v-html="errors[0]"
                            ></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-3">
                    <ValidationProvider
                        name="requirement_list"
                        rules="required"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('requirement_list')">
                            <b-form-textarea
                            ></b-form-textarea>
                            <b-form-invalid-feedback
                                v-if="errors[0]"
                                v-html="errors[0]"
                            ></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-3">
                    <ValidationProvider
                        name="salon_düzeni"
                        rules=""
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('hall_setup')">
                            <b-form-textarea
                                v-model="form.hall_setup"
                            ></b-form-textarea>
                            <b-form-invalid-feedback
                                v-if="errors[0]"
                                v-html="errors[0]"
                            ></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-3">
                    <ValidationProvider
                        name="transport_audio_video_systems"
                        rules=""
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('transport_audio_video_systems')">
                            <b-form-input
                                v-model="form.transport_audio_video_systems"
                            ></b-form-input>
                            <b-form-invalid-feedback
                                v-if="errors[0]"
                                v-html="errors[0]"
                            ></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>

                <div class="col-3">
                    <ValidationProvider
                        name="sponsor"
                        rules="required"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('sponsor')">
                            <b-form-input
                                v-model="form.sponsor"
                            ></b-form-input>
                            <b-form-invalid-feedback
                                v-if="errors[0]"
                                v-html="errors[0]"
                            ></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-3">
                    <ValidationProvider name="club" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('club')">
                            <department-selectbox  :multiple="true"
                                                   :validate-error="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-3">
                    <ValidationProvider
                        name="purpose"
                        rules="required"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('purpose')">
                            <b-form-textarea
                            ></b-form-textarea>
                            <b-form-invalid-feedback
                                v-if="errors[0]"
                                v-html="errors[0]"
                            ></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
            </div>
        </ValidationObserver>

        <div class="col-6 mt-3 d-flex">
            <b-button
                @click="createForm"
                type="button"
                :disabled="formLoading"
                variant="primary"
                class="btn-lg mr-2"
            >
                {{ $t("save") | toUpperCase }}
            </b-button>
        </div>
    </div>
</template>

<script>
    //Component
    //Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    //Service
    import CertificateCenterService from "@/services/CertificateCenterService";

    export default {
        components: {
            ValidationProvider, ValidationObserver,
        },
        data() {
            return {
                formLoading: false,
                form: {
                    name: null,
                },
                options: [
                    {
                        value: 'transkript',
                        text: this.$t('yes'),
                    },
                    {
                        value: 'student-certificate',
                        text: this.$t('no'),
                    }
                ]
            }
        },
        methods: {
            async createForm() {
                const isValid = await this.$refs.formModalValidate.validate()
                if (isValid) {
                    this.formLoading = true;
                    CertificateCenterService.store(this.form)
                                    .then((response) => {
                                        this.$toast.success(this.$t("api." + response.data.message));
                                        this.$emit("createFormSuccess")
                                    })
                                    .catch((error) => {
                                        this.showErrors(error, this.$refs.formModalValidate)
                                    }).finally(() => {
                        this.formLoading = false;
                    });
                }
            }
        }
    }
</script>
